import FlightLandIcon from "@mui/icons-material/FlightLand";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import { Stack, Typography } from "@mui/material";
import { format, parseISO } from "date-fns";
import React from "react";
import { TripWithTenant } from "../types";
import { formatDepartureDate } from "../utils/dateHelpers";

interface TripListDisplayProps {
  trips: TripWithTenant[];
  showTailNumber?: boolean;
  compact?: boolean;
}

export const TripListDisplay: React.FC<TripListDisplayProps> = ({
  trips,
  showTailNumber = false,
  compact = false,
}) => {
  if (trips.length === 0) {
    return (
      <Typography variant="caption" color="text.secondary">
        No trips found
      </Typography>
    );
  }

  return (
    <Stack spacing={compact ? 0.5 : 1}>
      {trips.map((trip) => (
        <Stack key={trip.trip_id} spacing={0.25}>
          {showTailNumber && (
            <Typography variant="caption" fontWeight={500}>
              {trip.tail_number} - {trip.owner_manager || "No owner"}
            </Typography>
          )}
          <Stack direction="row" spacing={1} alignItems="center">
            <FlightLandIcon sx={{ fontSize: 12, color: "text.secondary" }} />
            <Typography variant="caption">
              {format(parseISO(trip.arrival_date), "MMM d, h:mm a")}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              -
            </Typography>
            <FlightTakeoffIcon sx={{ fontSize: 12, color: "text.secondary" }} />
            <Typography variant="caption">
              {formatDepartureDate(trip.departure_date)}
            </Typography>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};